import { useTranslation } from "react-i18next";
import { TrendingUp } from "lucide-react";

export default function PerformancePage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 text-center">
        <TrendingUp className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          Module Performance
        </h3>
        <p className="text-gray-600 dark:text-gray-400">
          Module en développement - Évaluation des performances
        </p>
      </div>
    </div>
  );
}




























